// extracted by css-extract-rspack-plugin
export default {"watchListPopover":"watchListPopover-ux8suA","watchListPopoverTitle":"watchListPopoverTitle-mhtL3T"};